import { render, staticRenderFns } from "./PayrollPayRatesForm.vue?vue&type=template&id=74974708&scoped=true&"
import script from "./PayrollPayRatesForm.vue?vue&type=script&lang=js&"
export * from "./PayrollPayRatesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74974708",
  null
  
)

export default component.exports